<template>
  <div class="area">


    <div class="areaHead">
      <div class="it">
        玩家评价
        <span v-if="Count>0">
          (共
          <i>{{Count}}</i>条评论)
        </span>
      </div>
   
      <div class="comment-filter" >
        <span :class="{'on':sort == 'default'}" @click="sortSel('default')">默认</span>
        <span class="new" :class="{'on':sort == 'new'}" @click="sortSel('new')">最新</span>
        <span class="sort" :class="{'on':listType != 'all'}" @click="sortShow">筛选</span>

        <div class="comment-filter-item" v-if="showListType">
          <ul>
            <li
              v-for="(item,index) in listTypeList"
              :key="index"
              :class="{'on':item.it == listType}"
              @click="sortType(item.it)"
            >{{item.val}}</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- <div class="comment-btn">
      <a class="fl" @click="popdown">
        <i class="it1"></i>我要安利
      </a>
      <a class="fr" @click="popdown">
        <i class="it2"></i>我要评价
      </a>
    </div> -->

    <div class="comment-nodata" v-if="isNone&&!isLoad&&listType=='all'">
      这里欠缺一位像你这样勇于发言的人
      <br />
      <a>现在去发言</a>
    </div>

    <div class="comment-list">
      <Citem v-for="(item,index) in comList" :key="index" :itData="item"></Citem>
    </div>

    <div class="loadtips" v-if="isLoad">
      <span class="ico"></span>
      <span>正在加载中...</span>
    </div>

    <div class="comment-load" v-if="loadBtn&&!isLoad" @click="getData">
      加载更多 <span></span>
    </div>

    <div class="loadtips" v-if="isLoadEnd&&comList.length>0">没有更多评论</div>

    <div
      class="loadtips"
      style="padding:.4rem 0"
      v-if="isLoadEnd&&comList.length==0&&listType!='all'"
    >{{loadtxt}}</div>

    <a class="comment-fixed" @click="popdown">写评价</a>
    <div class="comment-filter-mask" v-show="showListType" @click="sortShow"></div>
    
  </div>
 
</template>

<script>
import Api from "@/tool/Api";


import Star from "@/components/Cstar.vue";
import Citem from "@/components/Citem.vue";

export default {
  data() {
    return {
      pid: window.pid,
      fid: window.fid,
      score: 0, //评分值
      limit: 10, //单页显示评论数
      isAnli: 0, //是否显示安利
      sort: "default",
      listType: "all",
      showListType: false,
      lastId: 0,
      cursor: 0,
      isLoad: true, //是否加载
      isNone: false, //无数据
      listTypeList: [
        { it: "all", val: "全部评价" },
        { it: "star1", val: "1 ★" },
        { it: "star2", val: "2 ★" },
        { it: "star3", val: "3 ★" },
        { it: "star4", val: "4 ★" },
        { it: "star5", val: "5 ★" },
        { it: "play_time", val: "有游戏时长" }
      ],
      Count: 0, //评论总数
      comList: [], //评论数据
      starInfo: null, //星级数据
      loadBtn: false,
      noLoadData: false,
      isLoadEnd: false, //加载结束
      isLoadNum: 0 //加载次数
    };
  },
  components: {
    Star,
    Citem
  },
  computed: {
    //加载无数据文本提示
    loadtxt() {
      let tempType = this.listTypeList.find(x => x.it == this.listType);
      return "暂无 " + tempType.val + " 类型的数据";
    }
  },
  mounted() {
    this.score = parseFloat(window.fscore);
    //获取数据
    this.getData();
  },
  methods: {
    setInit() {
      this.lastId = 0;
      this.cursor = 0;
      this.comList = [];
      this.loadBtn = false;
      this.noLoadData = false;
      this.isLoadEnd = false;
      this.isLoadNum = 0;
    },
    getData() {
      //加载评论3页后不加载 弹窗下载app
      if (this.isLoadNum == 3) {
        this.popdown();
        return;
      }
      this.isLoad = true; // 显示加载状态
      Api.getComment({
        get_recommend: this.isAnli,
        limit: this.limit,
        fid: this.fid,
        pid: this.pid,
        sort: this.sort,
        list_type: this.listType,
        last_id: this.lastId,
        cursor: this.cursor
      }).then(res => {
        this.isLoadNum++;
        this.isLoad = false; // 隐藏加载状态
        if (res.code == 100) {

           //翻页加载
          if (res.result.cursor > 0 || res.result.last_id > 0) {
            this.cursor = res.result.cursor;
            this.lastId = res.result.last_id;
            this.loadBtn = true;
          } else {
            this.loadBtn = false;
            this.isLoadEnd = true;
          }
          let tempArr=res.result.data.list.filter(item=>{
            return item.state>0
          })
         if(tempArr.length>0){
            //评论
            this.comList = this.comList.concat(tempArr);
            this.isLoadNum++;
          }else{
            if(!this.isLoadEnd){
               this.getData();
            }           
          }
          
          //星级数据
          if (res.result.star_info) {
            this.starInfo = res.result.star_info;
          }
          //评论总数
          if(res.result.data.hasOwnProperty("count")){
            if(res.result.data.count==0&&res.result.data.list.length==0){
              this.isNone=true;
            }else if(res.result.data.count==0&&res.result.data.list.length>0){
              this.isUserHide=true
            }
            else{
              this.Count = res.result.data.count;
            }
          }
        }
      });
    },
    //外部下载弹窗
    popdown() {
      window.comInit.downTips();
    },

    //筛选展示
    sortShow() {
      this.showListType = !this.showListType;
    },
    sortSel(val) {
      if (this.sort != val) {
        this.sort = val;
        this.setInit();
        this.getData();
      }
    },
    //筛选类别
    sortType(val) {
      if (this.listType != val) {
        this.listType = val;
        this.setInit();
        this.getData();
      }
      this.sortShow();
    },
    //demoLoad
    demoLoad() {
      this.setInit();
      this.getData();
    }
  }
};
</script>

